import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../../records/grids/columns/columnDefinitionService";
import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineDenomination";

const url = "/api/machines/MachineDenomination";

export const machineDenominationLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "Denomination",
    url,
    defaultSort: "Value",
    additionalColumns: [
      ColumnDefinitionServiceName,
      (columnDefinitionService: ColumnDefinitionService) => [
        columnDefinitionService.getNumberColDef({
          field: "Value",
        }),
      ],
    ],
    additionalFields: [
      () => [
        fieldHelpers.simpleNumberField({
          key: "Value",
          required: true,
          min: 0,
          step: 0.01,
        }),
      ],
    ],
  }
);
